import { http } from "../../services/http";
import { getUploadAttachmentsEndpoint } from "./attachmentEndpoints";

class AttachmentApi {

    uploadAttachments(appointmentId: string, data: any) {
        return http.post(getUploadAttachmentsEndpoint(appointmentId), data);
    }
}

export const attachmentApi = new AttachmentApi();